import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// @mui/icons-material
import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';

import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import GridItem from 'components/Grid/GridItem';
import Dinero from 'dinero.js';
import { getCurrencyFormat } from '../../helpers/currency';
import { useGetTenantQuery } from 'api/tenant.api';

const entrystyle = {
  padding: '8px 1px 1px 20px',
  textAlign: 'left',
  minWidth: '200px',
};

const countstyle = {
  padding: '1px 1px 1px 1px',
  textAlign: 'center',
  width: '260px',
};

export default function CountHistory(props) {
  const {
    type,
    history: { count, last_count: lastCount, cash_logs: cashLogs },
  } = props;
  const { data: tenant } = useGetTenantQuery();
  const currencyFormat = getCurrencyFormat(tenant?.base_currency);

  const cashOutFlow = {
    cashin: false,
    cashout: true,
    transferin: false,
    transferout: true,
    payment: false,
    refund: true,
    bankdeposit: true,
  };

  const activityLabel = {
    cashin: 'Pay In',
    cashout: 'Pay Out',
    transferin: 'Transfer In',
    transferout: `${type === 'Safe' ? 'Safe Deposit' : 'Cash Deposit'}`,
    payment: 'Payment',
    refund: 'Refund',
    cashcount: `Reserve From ${
      type === 'Safe' ? 'Safe Deposit' : 'Cash Count'
    }`,
    bankdeposit: 'Bank Deposit',
  };

  const activityIcon = {
    cashin: <Add />,
    cashout: <Remove />,
    transferin: <Add />,
    transferout: <Remove />,
    payment: <Add />,
    refund: <Remove />,
    bankdeposit: <Remove />,
  };

  const activityColor = {
    cashin: 'primary',
    cashout: 'error',
    transferin: 'primary',
    transferout: 'error',
    payment: 'primary',
    refund: 'error',
    bankdeposit: 'error',
  };

  const content = (entry) => {
    return (
      <Paper elevation={3} style={entrystyle}>
        <Typography variant="h6" component="span">
          {Dinero(entry.amount).toFormat(currencyFormat)}
          {'  ' + activityLabel[entry.action]}
        </Typography>
          <Typography>
          <p>
            Time: <br />
            {new Date(entry.created_at).toLocaleString()}
          </p>
          <p>
            Workstation:
            <br /> {entry.workstation}
          </p>
          <p>
            Cashier:
            <br /> {entry.user_id}
          </p>
          <p>{entry.reason ? entry.reason.label : ''}</p>
            {entry.comment ? (
              <p>
                Comment:
                <br />
                {entry.comment}
              </p>
            ) : null}
        </Typography>
      </Paper>
    );
  };
  const timeLineContent = (entry) => {
    return cashOutFlow[entry.action] ? content(entry, false) : '';
  };

  const oppositeContent = (entry) => {
    return !cashOutFlow[entry.action] ? content(entry, true) : '';
  };

  const timeLineEntry = (entry) => {
    return (
      <TimelineItem>
        <TimelineOppositeContent>
          {oppositeContent(entry)}
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color={activityColor[entry.action]}>
            {activityIcon[entry.action]}
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>{timeLineContent(entry)}</TimelineContent>
      </TimelineItem>
    );
  };

  const timeLineEntries = () => {
    const entries = cashLogs.map((entry) => timeLineEntry(entry));
    return entries;
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="form-dialog-title"
      fullWidth="true"
      maxWidth="md"
    >
      <DialogTitle id="form-dialog-title">Cash Count History</DialogTitle>
      <DialogContent>
        <Grid container alignItems="center" justifyContent="center">
          <GridItem xs={4} />
          <GridItem xs={4}>
            <Paper elevation={3} style={countstyle}>
              <Typography variant="h6" component="span">
                <p>Starting Count</p>
                {lastCount ? (
                  <p>{Dinero(lastCount.amount).toFormat(currencyFormat)}</p>
                ) : (
                  <p>Not Found!</p>
                )}
              </Typography>
              <Typography>
                {lastCount
                  ? new Date(lastCount.created_at).toLocaleString()
                  : ''}
              </Typography>
            </Paper>
          </GridItem>
          <GridItem xs={4} />
          <GridItem xs={12}>
            <Timeline>{timeLineEntries()}</Timeline>
          </GridItem>
          <GridItem xs={4} />
          <GridItem xs={4}>
            <Paper elevation={3} style={countstyle}>
              <Typography variant="h6" component="span">
                <p>Ending Count</p>
                <p>{Dinero(count.amount).toFormat(currencyFormat)}</p>
              </Typography>
              <Typography>
                <p>{new Date(count.created_at).toLocaleString()}</p>
                <p>
                  Discrepancy: {Dinero(count.delta).toFormat(currencyFormat)}
                </p>
                <p>Count reason: {count.reason.label}</p>
                <p>Cashier: {count.user_id}</p>
                {count.comment ? (
                  <p>
                    Comment:
                    <br />
                    {count.comment}
                  </p>
                ) : null}
              </Typography>
            </Paper>
          </GridItem>
          <GridItem xs={4} />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
